import * as v from 'valibot';
export const GalleryImage = v.object({
    id: v.number(),
    createadAt: v.string(),
    url: v.pipe(v.string(), v.url())
});
export var GallerySchema;
(function (GallerySchema) {
    GallerySchema.Image = v.object({
        id: v.number(),
        createdAt: v.string(),
        url: v.pipe(v.string(), v.url())
    });
    GallerySchema.ListResponse = v.object({
        images: v.array(GallerySchema.Image)
    });
    GallerySchema.DetailRespone = v.object({
        image: GallerySchema.Image
    });
    GallerySchema.Form = v.object({
        url: v.pipe(v.string(), v.string()),
        id: v.number()
    });
})(GallerySchema || (GallerySchema = {}));
